import Cookies, { CookieAttributes } from "js-cookie";
import { setSiteCookie } from "./set-cookies";

export const getToken = () => {
  const cookieOptions: CookieAttributes = {
    path: "/",
    expires: 30,
    secure: true,
    sameSite: "Lax",
  };

  if (typeof window === "undefined") {
    return null;
  }

  let token = Cookies.get("auth_token");

  if (!token) {
    const localToken = localStorage.getItem("token");
    if (localToken) {
      if (Cookies.get("auth_token") !== localToken) {
        setSiteCookie("auth_token", localToken, cookieOptions);
      }
      localStorage.removeItem("token");
      token = localToken;
    }
  }

  const currentUser = localStorage.getItem("currentUser");
  if (currentUser) {
    if (Cookies.get("user") !== currentUser) {
      setSiteCookie("user", currentUser, cookieOptions);
    }
    try {
      const userData = JSON.parse(currentUser);
      if (userData && userData.pk !== undefined) {
        const userIdValue = String(userData.pk);
        if (Cookies.get("user_id") !== userIdValue) {
          setSiteCookie("user_id", userIdValue, cookieOptions);
        }
      }
    } catch (error) {
      console.error("Error currentUser JSON:", error);
    }
    localStorage.removeItem("currentUser");
  }

  const choosedLanguage = localStorage.getItem("choosedLanguage");
  if (choosedLanguage) {
    if (Cookies.get("NEXT_LOCALE") !== choosedLanguage) {
      setSiteCookie("NEXT_LOCALE", choosedLanguage, cookieOptions);
    }
    localStorage.removeItem("choosedLanguage");
  }

  const cookieAccepted = localStorage.getItem("cookie:accepted");
  if (cookieAccepted === "true") {
    if (Cookies.get("accept_cookies") !== "accepted") {
      setSiteCookie("accept_cookies", "accepted", cookieOptions);
    }
    localStorage.removeItem("cookie:accepted");
  }

  return token;
};